'use client';

import React from 'react';
import { getLocale } from '@/i18n/locale';
import { getServerT } from '@/i18n/i18nInstance';

// Replaces pages/_error.tsx. Project does not currently depend on @sentry/nextjs;
// when Sentry is added back, capture the error here in a useEffect.
//
// getServerT is server-*safe*, not server-only — it reads the sync i18next
// instance with no react-i18next binding, which is exactly what this surface
// needs: global-error replaces the root layout, so no I18nextProvider exists
// when it renders.
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = getServerT('common');
  return (
    <html lang={getLocale()}>
      <body>
        <main style={{ padding: 24 }}>
          <h2>{t('common.somethingWentWrong')}</h2>
          <p style={{ color: '#888', fontSize: 12 }}>{error.digest ?? error.message}</p>
          <button type="button" onClick={() => reset()}>{t('common.tryAgain')}</button>
        </main>
      </body>
    </html>
  );
}
